export default __webpack_public_path__ + "static/media/points.317e591e.svg";